import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const Login = () => import('@/views/login')
const Register = () => import('@/views/login/register.vue')
const ForgetPassword = () => import('@/views/login/forgetPassword.vue')

const Index = () => import('@/views/home')

const Profile = () => import('@/views/profile/view.vue')
const Center = () => import('@/views/profile/center')
const Collection = () => import('@/views/profile/collection')
const Bids = () => import('@/views/profile/bids')
const Invitation = () => import('@/views/profile/invitation')
const Message = () => import('@/views/profile/message')
const Info = () => import('@/views/profile/info')
const Projects = () => import('@/views/profile/projects')

const Bid = () => import('@/views/bid')
const BidDetail = () => import('@/views/bid/detail.vue')
const PreviewDetail = () => import('@/views/bid/preview-detail.vue')

const News = () => import('@/views/news')
const NewsList = () => import('@/views/news/list.vue')
const NewsDetail = () => import('@/views/news/detail.vue')
const ProjectDetail = () => import('@/views/news/project-detail.vue')

const Download = () => import('@/views/download')

const routes = [
  {
    path: '/',
    redirect: {
      name: 'index'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: ForgetPassword
  },
  {
    path: '/index',
    name: 'index',
    component: Index
  },
  {
    path: '/profile',
    name: 'profile',
    redirect: {
      name: 'center'
    },
    component: Profile,
    children: [
      {
        path: 'center',
        name: 'center',
        component: Center,
        meta: {
          title: '个人中心'
        }
      },
      {
        path: 'collection',
        name: 'collection',
        component: Collection,
        meta: {
          title: '我的收藏'
        }
      },
      {
        path: 'bids',
        name: 'bids',
        component: Bids,
        meta: {
          title: '我的投标'
        }
      },
      {
        path: 'invitation',
        name: 'invitation',
        component: Invitation,
        meta: {
          title: '我的邀约'
        }
      },
      {
        path: 'message',
        name: 'message',
        component: Message,
        meta: {
          title: '我的消息'
        }
      },
      {
        path: 'info',
        name: 'info',
        component: Info,
        meta: {
          title: '企业信息管理'
        }
      },
      {
        path: 'projects',
        name: 'projects',
        component: Projects,
        meta: {
          title: '项目经验管理'
        }
      }
    ]
  },
  {
    path: '/bid',
    redirect: {
      path: '/bid/notice'
    }
  },
  {
    path: '/bid/:state',
    name: 'bid',
    component: Bid
  },
  {
    path: '/bid-detail',
    name: 'bidDetail',
    component: BidDetail
  },
  {
    path: '/preview-detail',
    name: 'previewDetail',
    component: PreviewDetail
  },
  {
    path: '/news',
    name: 'news',
    component: News
  },
  {
    path: '/news-list',
    name: 'newsList',
    component: NewsList
  },
  {
    path: '/news-detail',
    name: 'newsDetail',
    component: NewsDetail
  },
  {
    path: '/project-detail',
    name: 'projectDetail',
    component: ProjectDetail
  },
  {
    path: '/download',
    name: 'download',
    component: Download
  },

  // 404页面
  {
    path: '*',
    redirect: {
      name: 'index'
    }
  }
]

const router = new VueRouter({
  routes,
  // mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  const { user } = store.state

  // 已经登录过
  if (to.name === 'login') {
    if (user) {
      next({
        name: 'index',
        replace: true
      })

      return
    }
  }

  // 个人中心拦截
  if (to.matched.some(val => val.name === 'profile')) {
    if (!user) {
      Vue.prototype.$message.error('请先登录')
      next({
        name: 'login',
        replace: true
      })

      return
    }
  }

  next()
})

export default router
